import React, { useEffect } from 'react'
import { Column } from 'primereact/column'
import { useIntl } from 'react-intl'
import { DateTime } from 'luxon'
import { ColumnGroup } from 'primereact/columngroup'
import { Row } from 'primereact/row'
import { DataTableFun } from '../../../utils/helpers/dataTableFun'
import DataTableComp from '../../common/data-table/DataTableComp'
import { formatFuelQuantity } from '../../../utils/helpers/common'
import './purchase-summary-datatable.scss'

const PurchaseSummaryDataTable = ({
  loading = false,
  value,
  pagerOptions,
  sortOptions,
}) => {
  const { formatMessage: msg } = useIntl()
  const dataTablePaddingBottom = 80

  const formatDateToString = (date) => {
    const dt = DateTime.fromISO(date)
    return dt.setLocale('es-Es').toLocaleString(DateTime.DATETIME_SHORT)
  }

  useEffect(() => {
    // BEGIN: DataTable Responsive Pattern
    window.addEventListener(
      'resize',
      DataTableFun.responsiveResize(dataTablePaddingBottom),
    )
    return () => {
      window.removeEventListener(
        'resize',
        DataTableFun.responsiveResize(dataTablePaddingBottom),
      )
    }
    // END: DataTable Responsive Pattern
  }, [])

  const renderHeaderGroup = (
    <ColumnGroup>
      <Row>
        <Column
          field="centerName"
          header={msg({ id: 'center' })}
          style={{ minWidth: '180px' }}
          sortable
        />
        <Column
          field="supplierName"
          header={msg({ id: 'supplier' })}
          style={{ minWidth: '320px' }}
          sortable
        />
        <Column
          field="createdAt"
          header={msg({ id: 'date' })}
          style={{ minWidth: '240px' }}
          align="right"
          alignHeader="right"
          sortable
        />
        <Column
          field="GOA"
          header="GOA"
          align="right"
          style={{ minWidth: '160px' }}
          sortable
        />
        <Column
          field="G95"
          header="G95"
          align="right"
          style={{ minWidth: '160px' }}
          sortable
        />
        <Column
          field="GOAPLUS"
          header="GOAPLUS"
          align="right"
          style={{ minWidth: '160px' }}
          sortable
        />
      </Row>
    </ColumnGroup>
  )

  return (
    <DataTableComp
      loading={loading}
      pagerOptions={pagerOptions}
      tableOptions={{
        loading,
        headerColumnGroup: renderHeaderGroup,
        className: 'fuel-stations-summary-datatable',
        scrollable: true,
        // scrollHeight: DataTableFun.responsiveHeight(dataTablePaddingBottom),
        value,
        size: 'small',
        ...sortOptions,
      }}
      columns={[
        <Column field="centerName" sortable />,
        <Column field="supplierName" sortable />,
        <Column
          field="createdAt"
          className="border-right"
          body={(rowData) =>
            rowData?.createdAt
              ? formatDateToString(rowData?.createdAt)
              : undefined
          }
          align="right"
          sortable
        />,
        <Column
          field="GOA"
          className="price-col alt-col border-left"
          style={{ textAlign: 'right' }}
          body={(rowData) => formatFuelQuantity(rowData?.GOA, true)}
        />,
        <Column
          field="G95"
          className="price-col alt-col border-left"
          style={{ textAlign: 'right' }}
          body={(rowData) => formatFuelQuantity(rowData?.G95, true)}
        />,
        <Column
          field="GOAPLUS"
          className="price-col alt-col border-left"
          style={{ textAlign: 'right' }}
          body={(rowData) => formatFuelQuantity(rowData?.GOAPLUS, true)}
        />,
      ]}
    />
  )
}

export default PurchaseSummaryDataTable
